import { render, staticRenderFns } from "./BannersCarousel.vue?vue&type=template&id=fdc2a3ce"
import script from "./BannersCarousel.vue?vue&type=script&lang=ts"
export * from "./BannersCarousel.vue?vue&type=script&lang=ts"
import style0 from "./BannersCarousel.vue?vue&type=style&index=0&id=fdc2a3ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports